 // blink twice twice
$(document).ready(function() {
$('.blink')
   .delay(1500)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(200)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(10000)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50)
   .delay(200)
   .fadeOut(50)
   .delay(30)
   .fadeIn(50);
});


// Links on mobileShow

(function ($) {
        if ($(window).width() < 481) {
          $(".personel-block").click(function(){
            window.location = $(this).attr("data-href");
            return false;
          });
        }
})(jQuery);

function smoothScrollToSelector(selector) {
	//poor man's sync
	if(window.isOngoingSmoothScroll != true) {
		window.isOngoingSmoothScroll = true;
		$('html, body').animate({
			scrollTop: $(selector).offset().top
	    }, 900, function() {
	    	// not necessary to reflect scroll in window.location, as that is managed by angular anyway
	        // window.location.hash = selector;
	    	
	    	//poor man's sync
	    	window.isOngoingSmoothScroll = false;
	    });	
	}
};

(function ($) {
    // Add smooth scrolling to jetzt Termin buchen
    $("a.smooth-scroll").on('click', function(event) {
        event.preventDefault();
        var hash = this.hash;
        smoothScrollToSelector(hash);
    });
})(jQuery);

function initializeSmoothScrolling() {
	//initialize poor man's sync
	window.isOngoingSmoothScroll = false;
    // Add smooth scrolling to arrow-down on landing-page
    $("a.smooth-scroll").on('click', function(event) {
        event.preventDefault();
        var hash = this.hash;
        smoothScrollToSelector(hash);
    });
}

$('.ls-modal').on('click', function(e){
  e.preventDefault();
  $('.modal-title').text($(this).text());
  $('.modal-body').attr('style', '');
  $('#myModal').modal('show').find('.modal-body').load($(this).attr('href'));
});

$('.ls-modal-inline').on('click', function(e){
  e.preventDefault();
  $('.modal-title').text($(this).text());
  $('.modal-body').attr('style', 'white-space: pre-wrap;');
  $('#myModal').modal('show').find('.modal-body').text($(this).attr('data-text'));
});

function initializeSafariLinkFix() {
    $('a.external-link').click( function (event) {
        var target = $(event.currentTarget).attr('data-href') ? $(event.currentTarget).attr('data-href') : $(event.currentTarget).attr('href');
        window.location.href = target;
        return;
    });
}

initializeSafariLinkFix();
